/**
 * Created by Jerker Nord on 2018-11-27.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorFSBonusFeaturePlayingController} from "../../reelstoppresentation/fsbonusfeature/ThorFSBonusFeaturePlayingController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorParsedInitData} from "../../server/data/ThorParsedInitData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";

export class ThorRandomWildsWPController extends WinPresentationController {

    public static readonly ICON_SELECT_ANIMATION_COMPLETE:string = "ThorRandomWildsWPController_iconSelectAnimationComplete";
    public static readonly ICON_SELECT_ANIMATION_STARTED:string = "ThorRandomWildsWPController_iconSelectAnimationStarted";

    private _shouldPlayRandomWildSelect:boolean = false;
    private _wildsAddedAnimationPlaying:boolean = false;
    private _overlayWilds:boolean[][];
    private _addNewWildsTL:TimelineLite;
    private _disableOverlayWildsTL:TimelineLite;
    private _FSFeatureSelectEnded:boolean = false;
    private _FSMjolnirAnimationAborted:boolean = false;
    private _disableWilds:boolean;
    private _doRestore:boolean;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ThorRandomWildsWP", skippable : true});
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._wildsAddedAnimationPlaying = false;
        this._shouldPlayRandomWildSelect = false;
        this._FSMjolnirAnimationAborted = false;
        this._disableWilds = false;
        if(data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_RANDOM_WILDS) {
            this._shouldPlayRandomWildSelect = true;
            this._overlayWilds = this.getNewWilds(data.overlayWildsBeforeSpinStop, data.overlayWildsAfterSpinStop);
        }
        if((data.mode == ThorGameMode.FREESPIN || data.mode == ThorGameMode.NUDGE_RESPIN_FS) && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_RANDOM_WILDS) {
            this._shouldPlayRandomWildSelect = true;
            this._overlayWilds = this.getNewWilds(data.overlayWildsBeforeSpinStop, data.overlayWildsAfterSpinStop);
        }
        if((data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NORMAL) || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode !== ThorGameMode.NUDGE_RESPIN_FS)) {
            this._disableWilds = true;
        }
    }

    private getNewWilds(wildsBefore:boolean[][], wildsAfter:boolean[][]):boolean[][] {
        let newWilds:boolean[][] = [[false, false, false], [false, false, false], [false, false, false], [false, false, false], [false, false, false]];

        for(let i:number = 0; i < wildsAfter.length; i++) {
            for(let j:number = 0; j < wildsAfter[i].length; j++) {
                if(wildsAfter[i][j] == true && wildsBefore[i][j] == false) {
                    newWilds[i][j] = true;
                } else {
                    newWilds[i][j] = false;
                }
            }
        }
        return newWilds;
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, ThorRandomWildsWPController.ICON_SELECT_ANIMATION_COMPLETE, ():void => this.onIconSelectanimationComplete());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_ENDED, ():void => this.onFSFeatureSelectEnded());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_MJOLNIR_ANIMATION_ABORTED, ():void => this.onMjolnirAnimationAborted());
    }

    private onInitDataParsed(data:ThorParsedInitData) {
        this._overlayWilds = data.overlayWilds!;
        this._doRestore = false;
        if((data.mode == ThorGameMode.NUDGE_RESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN)
            || (data.mode == ThorGameMode.NORMAL && data.nextMode == ThorGameMode.NUDGE_RESPIN)
            || (data.mode == ThorGameMode.NUDGE_RESPIN_FS && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)
            || (data.mode == ThorGameMode.FREESPIN && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS)) {
            this._doRestore = true;
        }
    }

    private onRestore():void {
        if(this._doRestore == true) {
            ThorGameModuleConfig.thorRandomWildsView.abort(this._overlayWilds);
        }
    }

    private onMjolnirAnimationAborted():void {
        this._FSMjolnirAnimationAborted = true;
    }

    private onFSFeatureSelectEnded():void {
        if(this._shouldPlayRandomWildSelect == true) {
            this._FSFeatureSelectEnded = true;
        }
    }

    private onIconSelectanimationComplete():void {
        if(this._shouldPlayRandomWildSelect == true) {
            if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
                this._addNewWildsTL.pause();
                this._addNewWildsTL.kill();
            }
            this._addNewWildsTL = new TimelineLite();
            this._addNewWildsTL.add(() => this._wildsAddedAnimationPlaying = true);
            this._addNewWildsTL.add(ThorGameModuleConfig.thorRandomWildsView.getAddNewWildsTL(this._overlayWilds));
            this._addNewWildsTL.add(() => this._wildsAddedAnimationPlaying = false);
            this._addNewWildsTL.add(() => {
                this.finish();
            });
        }
    }

    protected hasWin():boolean {
        if(this._shouldPlayRandomWildSelect || this._wildsAddedAnimationPlaying || this._disableWilds) {
            return true;
        }
        return false;
    }

    protected startWinPresentation():void {
        Logger.logDev(`${this.moduleName} startWinPresentation this._shouldPlayRandomWildSelect=${this._shouldPlayRandomWildSelect}, this._wildsAddedAnimationPlaying=${this._wildsAddedAnimationPlaying}, this._disableWilds=${this._disableWilds}, this._FSFeatureSelectEnded=${this._FSFeatureSelectEnded}`)
        if(this._shouldPlayRandomWildSelect == false && this._wildsAddedAnimationPlaying == false && this._disableWilds == false) {
            this.finish();
        }
        if(this._FSFeatureSelectEnded) {
            this._FSFeatureSelectEnded = false;
            this.onIconSelectanimationComplete();
        }
        if(this._disableWilds) {
            this.onDisableOverlayWilds();
        }
    }

    private onDisableOverlayWilds():void {
        if(this._disableOverlayWildsTL && this._disableOverlayWildsTL.isActive()) {
            this._disableOverlayWildsTL.pause();
            this._disableOverlayWildsTL.kill();
        }
        this._disableOverlayWildsTL = new TimelineLite();
        this._disableOverlayWildsTL.add(ThorGameModuleConfig.thorRandomWildsView.disableOverlayWilds());
        this._disableOverlayWildsTL.add(() => {
            this.finish();
        });
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            if(this._disableWilds == true) {
                if(this._disableOverlayWildsTL && this._disableOverlayWildsTL.isActive()) {
                    this._disableOverlayWildsTL.pause();
                    this._disableOverlayWildsTL.kill();
                }
                ThorGameModuleConfig.thorRandomWildsView.abortDisableOverlayWilds();
            }
            if(this._shouldPlayRandomWildSelect == true) {
                if(this._FSMjolnirAnimationAborted == false) {
                    ThorGameModuleConfig.thorMjolnirtimeView.abort();
                }
                ThorGameModuleConfig.thorRandomWildIconView.abort();
            }
            if(this._wildsAddedAnimationPlaying == true) {
                this._wildsAddedAnimationPlaying = false;
                if(this._addNewWildsTL && this._addNewWildsTL.isActive()) {
                    this._addNewWildsTL.pause();
                    this._addNewWildsTL.kill();
                }
            }
            if(this._disableWilds == false) {
                ThorGameModuleConfig.thorRandomWildsController.abort();
                ThorGameModuleConfig.thorRandomWildsView.abort(this._overlayWilds);
            }
        }
    }
}